import ThisModule from "./TextWithLineBreaks";

export default ThisModule;
